import React, { Children, Component } from "react"
import DataGrid from "../../components/DataGrid"
import { MathKatex2 } from "../../components/MathKatex"
import { Column } from "../../components/DataGrid/types/types"
import { alphanumericCompare } from "../../services/utils/sort-util"
import { NO_INFO_FOUND } from "../../constants"

export function GenericFlashcards(props: any) {
    let { flashcards } = props
    let data = flashcards.map(createData)

    return (
        <div className="teacher-flashcards-container">
            <div className="teacher-flashcards-info">
                <DataGrid
                    columns={columns}
                    className={"teacher-flashcards-table"}
                    data={data}
                    emptyText={NO_INFO_FOUND}
                />
            </div>
        </div>
    )
}

//--- Helpers ---

const sortable = false
const sortMethod = alphanumericCompare
const columns: Column[] = [
    {
        title: "FLASHCARD",
        dataProperty: "index",
        width: "85px",
        customTooltip: "Flashcard Index",
        sortable,
        sortMethod: sortMethod,
    },
    {
        title: "QUESTION",
        dataProperty: "frontInfo",
        width: "50%",
        customTooltip: "Flashcard Question",
        sortable,
        sortMethod: sortMethod,
    },
    {
        title: "ANSWER",
        dataProperty: "backInfo",
        width: "50%",
        customTooltip: "Flashcard Answer",
        sortable,
        sortMethod: sortMethod,
    },
]

const createData = (flashcardData: any, idx: number) => {
    let {cardFront, cardBack, category} = flashcardData
    let processedData = {
        index: {
            content: idx + 1,
            comparator: `${category}-${idx}`,
        },
        frontInfo: {
            content: <MathKatex2 mixedContent={cardFront}/>,
            comparator: cardFront,
        },
        backInfo: {
            content: <MathKatex2 mixedContent={cardBack}/>,
            comparator: cardBack,
        }
    }
    return {
        data: processedData,
        id: `teacher-flashcards-${idx}`
    }
}

